import { type BoxProps, Flex } from '@shared/components';

import ErrorPageComponent from './error-page-component';

export interface ErrorPageProps extends BoxProps {
  errorType: ErrorPageType;
}

export enum ErrorPageType {
  NO_PERMISSION = 'NO_PERMISSION',
  NO_CONTENT_VISIBILITY = 'NO_CONTENT_VISIBILITY',
  USER_NOT_ACTIVE = 'USER_NOT_ACTIVE',
  DATA_NOT_FOUND = 'DATA_NOT_FOUND',
}

const ErrorPageMessage: Record<ErrorPageType, string> = {
  [ErrorPageType.NO_PERMISSION]: 'ไม่มีสิทธิ์การเข้าถึง',
  [ErrorPageType.NO_CONTENT_VISIBILITY]: 'ไม่สามารถเข้าถึงเนื้อหานี้',
  [ErrorPageType.USER_NOT_ACTIVE]: 'ไม่สามารถเข้าใช้งานได้',
  [ErrorPageType.DATA_NOT_FOUND]: 'ไม่พบหน้าที่คุณกำลังค้นหา',
};

const ErrorPageDetail: Record<ErrorPageType, string> = {
  [ErrorPageType.NO_PERMISSION]: 'กรุณาติดต่อผู้ดูแลระบบ เพื่อขอสิทธิ์การเข้าถึง',
  [ErrorPageType.NO_CONTENT_VISIBILITY]: 'กรุณาติดต่อผู้ดูแลระบบ เพื่อขอเข้าถึงเนื้อหา',
  [ErrorPageType.USER_NOT_ACTIVE]:
    'เนื่องจากบัญชีของคุณอยู่ในสถานะ “Inactive” กรุณาติดต่อผู้ดูแลระบบ\nเพื่อตรวจสอบสถานะการใช้งาน',
  [ErrorPageType.DATA_NOT_FOUND]: 'เนื่องจากลิงก์ที่ใช้ไม่ถูกต้อง กรุณาตรวจสอบลิงก์อีกครั้ง',
};

export default function ErrorPage(props: Readonly<ErrorPageProps>) {
  const { errorType, ...restProps } = props;
  return (
    <Flex
      sx={{ justifyContent: 'center', alignItems: 'center', height: '100%', m: 'auto' }}
      {...restProps}
    >
      <ErrorPageComponent
        message={ErrorPageMessage[errorType]}
        detail={ErrorPageDetail[errorType]}
      />
    </Flex>
  );
}
